import type { WfProps } from './element';

const SHARE_URLS: Record<string, (url: string, title: string) => string> = {
  linkedin: (url) => `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
  twitter: (url, title) => `https://twitter.com/intent/tweet?url=${url}&text=${title}`,
  facebook: (url) => `https://www.facebook.com/sharer/sharer.php?u=${url}`,
};

/**
 * A share button marked up for Flowbase's social-share script (`fb-social-type`): opens the
 * network's share dialog for the current page in a popup.
 */
export function ShareLink({ as: Tag = 'a', children, ...props }: WfProps & { 'fb-social-type'?: string }) {
  const share = SHARE_URLS[props['fb-social-type'] ?? ''];
  return (
    <Tag
      {...props}
      onClick={(e: React.MouseEvent) => {
        if (!share) return;
        e.preventDefault();
        const url = share(encodeURIComponent(window.location.href), encodeURIComponent(document.title));
        window.open(url, '_blank', 'noopener,noreferrer,width=600,height=600');
      }}
    >
      {children}
    </Tag>
  );
}
